import { createContext, ReactNode, useContext } from 'react';

import { ReveiwListConfigValue } from '@common/review';
import { ThumbnailSize } from '@widgets/review-item-card';

const ReviewListConfigContext = createContext<ReveiwListConfigValue>({
  isZigzagApp: false,
  catalog_product_id: '',
  is_product_preview: false,
  path: { review: { list: () => '', best: () => '' } },
  thumbnailSize: ThumbnailSize.SMALL,
  isShowPredictionSummary: false,
});
export const useReviewListConfig = () => useContext(ReviewListConfigContext);

export function ReviewListConfigProvider({ children, value }: { value: ReveiwListConfigValue; children: ReactNode }) {
  return <ReviewListConfigContext.Provider value={value}>{children}</ReviewListConfigContext.Provider>;
}
